// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 36px;
  text-align: left; 
}

  .styled-link:hover {
    text-decoration: underline;
  }
  
  .box-add {
    margin-bottom: 20px;
  }
  
  .cont_details {
    display: flex;
    align-items: center;
  }
  
  .cont_details i {
    font-size: 24px;
    margin-right: 10px;
  }

  .aRemove:hover {
    text-decoration: none;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-control {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
  
  .theme-btn-contact {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    cursor: pointer;
  }
  
  .theme-btn-contact:hover {
    background-color: #0056b3;
  }
  
  .alert {
    margin-top: 10px;
  }
  
  .col-md-12 {
    padding: 10px;

  }

  .h3{
    text-align: left;
  }

  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
  
  .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  
  iframe {
    border: 0;
    width: 100%;
    height: 400px;
  }
  
  @media (width <= 768px) {
    .h3 {
      font-family: Lato, sans-serif;
      font-size: 1.5rem;
    }
  
    .form-control {
      padding: 8px;
    }
  
    .theme-btn-contact {
      padding: 8px 16px;
    }
  }

  .col-md-4 .location-item p{
    margin: 0; padding: 0; font-size: 14px;font-family: Jost, sans-serif;
  }
  

.location-item i {
    font-size: 30px; 
    color: #007bff;
    margin-right: 10px; 
}

.location-item p {
    font-size: 14px; 
    line-height: 1.6;
    margin-top: 10px;
    font-family: Jost, sans-serif;
    color: black;
}

.row {
    display: flex;
    flex-wrap: wrap;
}

.location-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%; 
    object-fit: cover; 
    margin-right: 10px; 
}


.contact-details-row {
  display: flex;
  flex-wrap: wrap;
  gap: 90px; /* Increase the gap between the phone and email sections */
  justify-content: flex-start;
}

.contact-details-column {
  display: flex;
  flex-direction: column;
}

.contact-details-column:first-child {
  margin-right: 40px; /* Add some space between the phone and email sections */
}

/* Ensure the text links are aligned properly */
.aRemove {
  text-decoration: none;
  color: #333;
  margin-bottom: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/contact.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;;EAEf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE;MACE,6BAA6B;MAC7B,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,SAAS,EAAE,UAAU,EAAE,eAAe,CAAC,6BAA6B;EACtE;;;AAGF;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,0DAA0D;EACrE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,wDAAwD;AAC9E;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["h1 {\n  font-size: 36px;\n  text-align: left; \n}\n\n  .styled-link:hover {\n    text-decoration: underline;\n  }\n  \n  .box-add {\n    margin-bottom: 20px;\n  }\n  \n  .cont_details {\n    display: flex;\n    align-items: center;\n  }\n  \n  .cont_details i {\n    font-size: 24px;\n    margin-right: 10px;\n  }\n\n  .aRemove:hover {\n    text-decoration: none;\n  }\n  \n  .form-group {\n    margin-bottom: 15px;\n  }\n  \n  .form-control {\n    width: 100%;\n    padding: 10px;\n    box-sizing: border-box;\n  }\n  \n  .theme-btn-contact {\n    background-color: #007bff;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .theme-btn-contact:hover {\n    background-color: #0056b3;\n  }\n  \n  .alert {\n    margin-top: 10px;\n  }\n  \n  .col-md-12 {\n    padding: 10px;\n\n  }\n\n  .h3{\n    text-align: left;\n  }\n\n  .alert-danger {\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n  }\n  \n  .alert-success {\n    color: #155724;\n    background-color: #d4edda;\n    border-color: #c3e6cb;\n  }\n  \n  iframe {\n    border: 0;\n    width: 100%;\n    height: 400px;\n  }\n  \n  @media (width <= 768px) {\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 1.5rem;\n    }\n  \n    .form-control {\n      padding: 8px;\n    }\n  \n    .theme-btn-contact {\n      padding: 8px 16px;\n    }\n  }\n\n  .col-md-4 .location-item p{\n    margin: 0; padding: 0; font-size: 14px;font-family: Jost, sans-serif;\n  }\n  \n\n.location-item i {\n    font-size: 30px; \n    color: #007bff;\n    margin-right: 10px; \n}\n\n.location-item p {\n    font-size: 14px; \n    line-height: 1.6;\n    margin-top: 10px;\n    font-family: Jost, sans-serif;\n    color: black;\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.location-icon {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%; \n    object-fit: cover; \n    margin-right: 10px; \n}\n\n\n.contact-details-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 90px; /* Increase the gap between the phone and email sections */\n  justify-content: flex-start;\n}\n\n.contact-details-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-details-column:first-child {\n  margin-right: 40px; /* Add some space between the phone and email sections */\n}\n\n/* Ensure the text links are aligned properly */\n.aRemove {\n  text-decoration: none;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
